import { useState } from "react";

import { Button } from "@/shared/ui/button";

import { Modal } from "@/shared/ui/Modal";
import { Textarea } from "@/shared/ui/textarea";
import { useNotificationBanner } from "@/entities/notification/api";

export const SendNotificationBanner = () => {
  const { mutateAsync } = useNotificationBanner();
  const [value, setValue] = useState("");

  const handleBroadcast = async () => {
    await mutateAsync({ message: value });
  };

  return (
    <Modal>
      <Modal.Trigger>Рассылка баннеров</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Рассылка баннеров</Modal.Title>
        <Textarea
          placeholder="Текст сообщения"
          onChange={(e) => setValue(e.target.value)}
          value={value}
          className="text-textColor"
        />
        <Button onClick={handleBroadcast}>Отправить</Button>

        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
